import { Component, OnInit, ViewChild } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from'@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'loyaltic-enter-code',
    templateUrl: './enter-code.component.html',
    styleUrls: ['./enter-code.component.scss'],
    standalone: false
})
export class EnterCodeComponent implements OnInit {

  slotId = '';
  userId = '';
  gameId = '';
  code = '';
  freeGameId  = '';
  paidGameId = '';
  slotNumber = '';
  popupKeysObj : any;
  isFreeGameAvaialble = false;
  isPaidGameAvaialble = false;
  public modalRef: BsModalRef;
  availableGamesResponse : any;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };
  @ViewChild('noGamesAvailable', { static: false }) noGamesAvailableRef: any;


  constructor(private coreService: CoreService, private modalService: BsModalService, private readonly router: Router,private toast: ToastrService, private readonly translate: TranslateService) { }

  ngOnInit() {
    let apiResult = JSON.parse(localStorage.getItem('participateApiResult'));
    this.slotId = apiResult.availableSlotIds[0];
    this.userId = apiResult.id;
    this.slotNumber = localStorage.getItem('slotNumber');
    this.getAvailableGames();
  }

  public redirectToSelectSlot() {
    this.modalRef.hide();
    this.router.navigate(['/select-slot'])
  }

  playFreeGame() {
    localStorage.setItem('playType', '0');
    localStorage.setItem('gameId', this.freeGameId);
    this.router.navigate(['/play']);
  }

  playPaidGame() {
    localStorage.setItem('playType', '1');
    let payload = {
      UserId: this.userId,
      Code: this.code
    }
    this.coreService.checkCode(payload).then((response:any)=> {
      localStorage.setItem('gameId', this.paidGameId);
      this.router.navigate(['/play']);
    }, (errorResponse:any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage);
    })
  }


  getAvailableGames() {
    this.coreService.getAvailableGames(this.userId, this.slotId).then((response: any) => {
      this.availableGamesResponse = response.result;
      this.availableGamesResponse.games.map(game => {
        if (game.isFree) {
          this.freeGameId = game.gameId;
        }
        if (!game.isFree) {
          this.paidGameId = game.gameId;
        }
        if(game.isFree && !game.isPlayed) {
          this.isFreeGameAvaialble = true;
        }
        if(!game.isFree && !game.isPlayed) {
          this.isPaidGameAvaialble = true;
        }
      })
      if (response.result.availableGames === 0) {
        this.popupKeysObj = {
          headerKey : 'pop-generic-header',
          bodyKey :  'pop-generic-body'
        }
        // this.showGenericPopup = true;

        this.modalRef = this.modalService.show(this.noGamesAvailableRef, this.popupConfig);
      }
    })
  }

}
